// extracted by mini-css-extract-plugin
export var colorSquare = "_p3-0";
export var danger = "_p3-5";
export var lightPink = "_p3-8";
export var neutralBlue = "_p3-7";
export var neutralYellow = "_p3-6";
export var normal = "_p3-1";
export var primary = "_p3-2";
export var primaryLight = "_p3-3";
export var solidBlack = "_p3-g";
export var solidGreen = "_p3-b";
export var solidLightBlue = "_p3-d";
export var solidNavy = "_p3-c";
export var solidOrange = "_p3-f";
export var solidPink = "_p3-e";
export var solidRed = "_p3-9";
export var solidYellow = "_p3-a";
export var success = "_p3-4";